module.exports = __webpack_public_path__ + "html/page-preloader.template.html";